module.exports = __webpack_public_path__ + "img/github.4788ac4e.svg";